import React, { useContext } from 'react';
import {
	AnalyticsWrapper,
	IdentityDocumentsWrapper,
	InstitutionAccountsWrapper,
	InstitutionsWrapper,
	TargetTypesWrapper,
	TargetsAllianzUtilsWrapper,
	TargetsWrapper,
	UserWrapper,
	VinculationsWrapper,
} from '@coinscrap/webapp-core';
import { AgentContext } from '../contexts/agent';

export const EntityWrappers = ({ children, ...props }) => {
	const { agent } = useContext(AgentContext);
	const transportsAnalytics = [
		{
			engine: AnalyticsWrapper.TRANSPORTS.COINSCRAP,
			initProps: {
				debugEnabled: false,
			},
		},
	];
	if (agent && agent.delioEnabled) {
		transportsAnalytics.push({
			engine: AnalyticsWrapper.TRANSPORTS.WALMERIC_DELIO,
			initProps: {
				debugEnabled: false,
				useMainScript: true, // Adds main script to generate leadId before making the GET request to walmeric. Debe estar configurado el micro de analytics de la misma manera con la variable → WALMERIC_DELIO_MAIN_SCRIPT
			},
		});
	}
	console.log('transportsAnalytics', transportsAnalytics);
	return (
		<UserWrapper enableRoles>
			<AnalyticsWrapper transports={transportsAnalytics}>
				<IdentityDocumentsWrapper>
					<VinculationsWrapper>
						<InstitutionsWrapper>
							<InstitutionAccountsWrapper>
								<TargetTypesWrapper>
									<TargetsWrapper>
										<TargetsAllianzUtilsWrapper>
											{children}
										</TargetsAllianzUtilsWrapper>
									</TargetsWrapper>
								</TargetTypesWrapper>
							</InstitutionAccountsWrapper>
						</InstitutionsWrapper>
					</VinculationsWrapper>
				</IdentityDocumentsWrapper>
			</AnalyticsWrapper>
		</UserWrapper>
	);
};
